import {
  createComponentMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import {
  GridDefinition,
  GridPlatformProps,
  GridProperties,
  GridCSSVars,
  GridPagination,
  GridSkin,
  GridHeaderColumn,
  GridHorizontalTextAlignment,
  GridHorizontalContentAlignment,
} from '../Grid.types';

const skinToHeaderColumnMap: Record<GridSkin, GridHeaderColumn> = {
  GridSkin: 'none',
  GridLeftHeaderSkin: 'first',
  GridRightHeaderSkin: 'last',
};

const horizontalContentAlignmentMap: Record<
  GridHorizontalTextAlignment,
  GridHorizontalContentAlignment
> = {
  center: 'center',
  left: 'flex-start',
  right: 'flex-end',
};

const mapPagination = ({
  type,
  rowsPerPage,
}: GridProperties['pagination']): GridPagination => ({
  type,
  rowsPerPage,
});

export const props = withCompInfo<GridPlatformProps, GridDefinition>()(
  ['skin', 'compProps', 'compData', 'compLayout', 'topology'],
  ({
    skin,
    compProps: {
      columns,
      showHeader,
      pagination,
      userSelectionType,
      dateFormat,
      linkTarget,
      columnLayout,
      rowHeight,
    },
    compData: { rows, dataSource },
    compLayout: { width },
    topology: { staticMediaUrl },
  }) => ({
    dataSource: dataSource.type,
    columns,
    rows,
    headerColumn: skinToHeaderColumnMap[skin],
    showHeader,
    pagination: mapPagination(pagination),
    userSelectionType,
    dateFormat,
    linkTarget,
    columnLayout,
    staticMediaUrl,
    rowHeight,
    width,
  }),
);

export const css = withCompInfo<GridCSSVars, GridDefinition>()(
  ['compProps', 'styleProperties'],
  ({
    compProps: { headerHeight, rowHeight, heightLayout, horizontalAlignment },
    styleProperties: { cellPadding },
  }) => ({
    ...(heightLayout === 'auto' && { height: 'auto' }),
    '--headerHeight': `${headerHeight}px`,
    '--rowHeight': `${rowHeight}px`,
    '--horizontalTextAlignment': horizontalAlignment,
    '--horizontalContentAlignment':
      horizontalContentAlignmentMap[horizontalAlignment],
    ...(horizontalAlignment === 'left' && { '--cellPaddingLeft': cellPadding }),
    ...(horizontalAlignment === 'right' && {
      '--cellPaddingRight': cellPadding,
    }),
  }),
);

export default createComponentMapperModel({ props, css });
